<!-- <h4 class="mb-16 chip-spacer" *ngIf="placeholder">{{placeholder}}</h4> -->
<span *ngIf="placeholder">{{placeholder}}</span>
<mat-chip-listbox appearance="outline" aria-label="type_selection">
    <mat-chip-option *ngFor="let option of options" [value]="option.value"
        (selectionChange)="onSelectionChange($event)">
        {{option.name}}
    </mat-chip-option>
</mat-chip-listbox>